import { render, staticRenderFns } from "./BaseTitle.vue?vue&type=template&id=af14de16&scoped=true"
import script from "./BaseTitle.vue?vue&type=script&lang=js"
export * from "./BaseTitle.vue?vue&type=script&lang=js"
import style0 from "./BaseTitle.vue?vue&type=style&index=0&id=af14de16&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af14de16",
  null
  
)

export default component.exports